import { Component, OnInit } from '@angular/core';
import { Icons } from '../../../shared/helpers/icons';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { EYesNo } from '../../../shared/models/types.enum';
import { AssessCaseService } from '../../../shared/services/assessCase.service';
import { StudentService } from '../../../shared/services/student.service';
import { StudentInfoComponent } from '../../components/student-info/student-info.component';
import { SpinnerComponent } from '../../components/spinner/spinner.component';
import { UserDataService } from '../../../shared/services/auth/userData.service';

@Component({
  selector: 'interventions-form',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    RouterOutlet,
    StudentInfoComponent,
    SpinnerComponent
  ],
  templateUrl: './interventions-form.component.html',
  styleUrl: './interventions-form.component.css'
})
export class InterventionsFormComponent implements OnInit {
  icons = Icons;
  yesNo = EYesNo;

  currentCaseId: string | null = null;
  currentBuildingId: string | null = null;
  regionId: string | null = null;
  studentSSID: string = '';
  studentInfo: any | null = null;
  currentAssessCase: any | null = null;
  messageModal: string | null = null;

  showStudentInfo: boolean = false;
  loading: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private assessCaseService: AssessCaseService,
    private studentService: StudentService,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.regionId = this.userDataService.getRegionId();
    
    this.route.firstChild?.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });
    if (this.currentCaseId) {
      this.assessCaseService.getAssessCaseByCaseId(this.currentCaseId).subscribe({
        next: (response) => {
          if (!response) {
            console.error('No assess case found for case id:', this.currentCaseId);
            this.currentAssessCase = null;
            return;
          } else {
            this.currentAssessCase = response;
          }
        },
        error: (error) => {
          console.error('Error fetching assess case:', error);
        }
      });
    }
  }
  
  handleOpenModal(type: string): void {
    if (type == 'student info') {
      if (this.currentCaseId) {
        // find student id by case id
        this.assessCaseService.getAssessCaseByCaseId(this.currentCaseId).subscribe({
          next: (response) => {
            this.studentSSID = response.student_identifier;
            // get student info by student id
            this.getStudentInfo();
          },
          error: (error) => {
            console.error('Error fetching assess case:', error);
          }
        });

      }
    }
  }

  getStudentInfo(): void {
    if (this.studentSSID && this.currentBuildingId && this.regionId) {
      this.loading = true;
      this.studentService.findStudentBySsid(this.regionId, {building_id: this.currentBuildingId, student_identifier: this.studentSSID}).subscribe({
        next: (res) => {
          this.loading = false;
          this.showStudentInfo = true;
          this.studentInfo = res.student;
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
        }
      });
    }
  }
  

  handleCloseModal(type: string): void {
    if (type == 'student info') {
      this.showStudentInfo = false;
    }
  }

  onBack(): void {
    this.router.navigate(['/interventions/']);
  }

}
